import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TableModule } from 'primeng/table';

import { AtividadeServico } from '../models/atividade-servico';
import { AtividadeServicosService } from './atividade-servicos.service';

@Component({
    selector: 'mf-atividade-servico',
    templateUrl: './atividade-servicos.component.html',
    styleUrls: ['atividade-servicos.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        TableModule
    ],
    providers: [AtividadeServicosService]
})
export class AtividadeServicosComponent implements OnInit {
  atividadeServicos: AtividadeServico[] = [];
  @Input() idAtividade: number = 0;
  loading: boolean = false;

  constructor(
    private atividadeServicosService: AtividadeServicosService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.getServicosAplicados();
    setTimeout(() => {
      this.atividadeServicos = this.atividadeServicos.map((item, index) => ({
        ...item,
        item: index + 1,
      }));
    }, 1000);
  }

  getServicosAplicados() {
    this.atividadeServicosService.getAtividadeServicosAplicados(this.idAtividade).subscribe((atvServicos) => {
      this.atividadeServicos = atvServicos;
      this.loading = false;
    });
  }
}
